import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../common/loader";
import { formatDateWithTime, formateDate } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
// import $ from "jquery";
import { Details } from "../../services/babeuser.services";
import Breadcrums from "../../common/breadcrumbs";
import { Placeholder} from "rsuite";
import ShowSkyflowImage from "../../../common/ShowSkyflowImage";


const BabeUserView = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const params = useParams();
  // const [query] = useSearchParams();
  const [showdefault, setShowDefault] = useState({});
  const [loader , setLoader] = useState(true);

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("Babe User"),
      url: "/admin/babe-user/list/1",
    },
    { title: t("btn_view"), url: "" },
  ];


  useEffect(() => {
    Details(params._id)
      .then((response) => {
        setTimeout(()=>setLoader(false) , 500)
        // console.log("View response-", response);
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        setTimeout(()=>setLoader(false) , 500) 
        console.log("error=====>", error);
      });
  }, [params._id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
               <div>
                <h6 className="main-content-label mb-3">{t("btn_view") + " " + t("Babe User")}</h6>
              </div>
              {!loader? (
                <div className="row">
                  {showdefault && Object.keys(showdefault).length > 0 ?(<div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>
                        <tr>
                          <th>{t("label_profile_image")}</th>
                          <td>
                            <ShowSkyflowImage table="users" column="profile_image" skyflowID={showdefault.skyflow_id} elementID=""
                                  style={{width:'100px', height:"100px"}}/>
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_name")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.name
                              ? showdefault.name
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("list_heading_status")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.status && showdefault.status === 1
                              ? t('btn_unblock')
                              : t('btn_block')}
                          </td>
                        </tr>




                        <tr>
                          <th>{t("label_email")}</th>
                          <td>
                            {showdefault && showdefault.email
                              ? showdefault.email
                              : "N/A"}
                          </td>
                        </tr>


                        <tr>
                          <th>{t("label_address")}</th>
                          <td>
                            {showdefault && showdefault.address && showdefault.address.address
                              ? showdefault.address.address
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_phone_number")}</th>
                          <td>
                            {showdefault && showdefault?.phone_number
                              ? showdefault.phone_number
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>
                            {showdefault && showdefault.createdAt
                              ? formatDateWithTime(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </div>):<div className="row" ><p className="text-center">{t('label_no_data_found')}</p> </div>}
                </div>
              ) : (
                <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7}/>
              )}
            </div>

            <div className="mt-2 back-button mx-4">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() =>
                  navigate("/admin/babe-user/list/1")
                }
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BabeUserView;
